
import Vue from 'vue';
import Token from '../Token';
import AddMore from '../../Icons/AddIconPrimary.vue';
import { Padder, Spacer as QSpacer } from '../Spacings';
import InlineUploader from '../InlineUploader/InlineUploader.vue';
/**
 * Inline Multi Uploader component.
 *
 * This can contain multiple InlineUploader components
 *
 * More events:
 *
 * - `add-more`: After User press add more row
 * - `after-delete-row`: After delete one row
 *
 */
export default Vue.extend<any, any, any, any>({
  name: 'InlineMultiUploader',
  components: {
    Padder,
    QSpacer,
    AddMore,
    InlineUploader
  },
  props: {
    /**
     * The ref key of the input.
     */
    documentKey: {
      type: String,
      default: ''
    },
    /**
     * The accept file of the input.
     */
    documentType: {
      type: String,
      default: 'image/*'
    },
    /**
     * Placeholder text when the file is empty.
     */
    placeholder: {
      type: String,
      default: 'Placeholder'
    },
    /**
     * Upload text button.
     */
    uploadLabel: {
      type: String,
      default: 'Upload'
    },
    /**
     * Loading text when uploading file.
     */
    loadingHint: {
      type: String,
      default: 'Uploading'
    },
    /**
     * Validation for minimal image height.
     */
    minImageHeight: {
      type: Number,
      default: 0
    },
    /**
     * Validation for minimal image width.
     */
    minImageWidth: {
      type: Number,
      default: 0
    },
    /**
     * Validation for maximal image height.
     */
    maxImageHeight: {
      type: Number,
      default: Number.POSITIVE_INFINITY
    },
    /**
     * Validation for maximal image width.
     */
    maxImageWidth: {
      type: Number,
      default: Number.POSITIVE_INFINITY
    },
    /**
     * The placeholder always shown instead of file name.<br />
     * `true` for fix placeholder, `false` for file name after uploading.
     */
    replacePlaceholder: {
      type: Boolean,
      default: false
    },
    /**
     * Make input file to capture image instead choosing file.
     * Possible value: `camera`
     */
    capture: {
      type: String,
      default: ''
    },
    /**
     * Delete Row Text
     */
    deleteRowText: {
      type: String,
      default: 'Delete Row'
    },
    /**
     * Add more text for adding a row
     */
    addMoreText: {
      type: String,
      default: 'Add More'
    },
    /**
     * Add Icon for multiuploading variant
     */
    addIcon: {
      type: Object,
      default: () => AddMore
    },
    /**
     * Variation of the Button.
     * Possible value: See **Eucalyptus** > **Button**
     */
    buttonVariant: {
      type: String,
      default: 'outline-primary'
    },
    /**
     * Variation of text inside Button.
     * Possible value: See **Eucalyptus** > **Text**
     */
    textVariant: {
      type: String,
      default: 'secondary'
    },
    /**
     * Value of the Inline Uploader.<br />
     * Bind in `v-model`.
     */
    value: {
      type: [String, Object],
      default: ''
    }
  },
  data() {
    return {
      listFiles: []
    };
  },
  created() {
    this.listFiles = this.value ? this.value : [];
  },
  methods: {
    addMore() {
      const data = {
        fileName: '',
        data: '',
        content: '',
        loading: false
      };
      const listFiles = this.listFiles.slice();
      listFiles.push(data);
      this.listFiles = listFiles;
      /**
       * Handle when user adds more photo (multiple variant)
       * @event add-more
       * @type {function}
       */
      this.$emit('add-more');
    },
    handleInput(e: any, index: number) {
      const listFiles = this.listFiles.slice();
      listFiles[index] = e;
      this.listFiles = listFiles;
      /**
       * Handle when value is inputted
       * @event input
       * @type {function}
       */
      this.$emit('input', this.listFiles, index);
    },
    handleAfterRead(e: any, index: number) {
      /**
       * Handle when file is after read
       * @event after-read
       * @type {function}
       */
      this.$emit('after-read', this.listFiles, index);
    },
    handleErrorState(e: any, index: number) {
      /**
       * Handle state of error
       * @event error-state
       * @type {function}
       */
      this.$emit('error-state', e, index);
    },
    handleDelete(e: any, index: number) {
      /**
       * Handle when file is deleted
       * @event after-delete
       * @type {function}
       */
      this.$emit('after-delete', e, index);
    },
    handleDeleteRow(e: any, index: number) {
      const listFiles = this.listFiles.slice();
      // Put empty for resetting first
      // this.listFiles = [];
      this.listFiles = [...listFiles.slice(0, index), ...listFiles.slice(index + 1)];
      this.$emit('input', this.listFiles);
      /**
       * Handle when a row is deleted
       * @event after-delete-row
       * @type {function}
       */
      this.$emit('after-delete-row', e);
    },
    handleAddMore(e: any) {
      /**
       * Handle when user adds more row
       * @event add-more
       * @type {function}
       */
      this.$emit('add-more', e);
    }
  }
});
